import React, { FC, memo, useCallback } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props {
  title: string;
  href: string;
}

const Link: FC<Props> = ({ href, title }) => {
  const { classes } = useStyles();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.stopPropagation();
    },
    [],
  );

  return (
    <Typography variant="caption1" className={classes.linkBox}>
      <a href={href} target="_blank" rel="noreferrer" onClick={handleClick}>
        {title}
      </a>
    </Typography>
  );
};

export default memo(Link);
